import React, { useState } from 'react';
import { Box, Typography, Button, Chip } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import QuestCreationWizard from './QuestCreationWizard';

interface GameMasterPanelProps {
  customerId?: string;
}

const GameMasterPanel: React.FC<GameMasterPanelProps> = ({ customerId }) => {
  const [wizardOpen, setWizardOpen] = useState(false);

  return (
    <Box sx={{ p: 2, border: 1, borderColor: 'divider', borderRadius: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <AutoAwesomeIcon fontSize="small" color="primary" />
        <Typography variant="subtitle2">Game Master</Typography>
        <Chip label="AI" size="small" color="primary" variant="outlined" />
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        The Game Master generates quests from your platform data and adapts to team velocity.
        Create a quest by providing a high-level goal — the AI fills in the details.
      </Typography>
      <Button
        variant="outlined"
        size="small"
        startIcon={<AutoAwesomeIcon />}
        onClick={() => setWizardOpen(true)}
      >
        Create Quest
      </Button>

      <QuestCreationWizard
        open={wizardOpen}
        onClose={() => setWizardOpen(false)}
        customerId={customerId}
      />
    </Box>
  );
};

export default GameMasterPanel;
